module.exports = __webpack_public_path__ + "pn.8b1dcfe61ffd764ef806.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/pn.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/pn.svg
// module chunks = styles